"use strict";

_BannerFlowApp.directive("firstLoading", function ($state, $stateParams, $location) {
    return {
        restrict: "E",
        replace: true,
        template:
            '<div class="loading"><div class="loading"><div id="butterfly"><div class="wing-left"></div><div class="wing-right"></div></div></div></div>'
    };
});

/* Directives */
_BannerFlowApp.directive("loading", function ($state, $stateParams, $location) {
    return {
        restrict: "E",
        replace: true,
        //template: '<div class="loading"><i class="fa fa-cog fa-spin"></i></div>'
        template: '<div class="loading"><div class="spinner dark"></div></div></div>'
    };
});

_BannerFlowApp.directive("loadingSmall", function ($state, $stateParams, $location) {
    return {
        restrict: "E",
        replace: true,
        //template: '<div class="loading"><i class="fa fa-cog fa-spin"></i></div>'
        template:
            '<div class="loading small" style="height:150px;position:relative;z-index:1;"><div class="spinner dark"></div></div>'
    };
});

_BannerFlowApp.directive("loadingTiny", function ($state, $stateParams, $location) {
    return {
        restrict: "E",
        replace: true,
        template:
            '<div class="loading" style="z-index: 99999;background:transparent;"><div class="spinner small dark"></div></div>'
    };
});

_BannerFlowApp.directive("loadingIcon", function ($state, $stateParams, $location) {
    return {
        restrict: "E",
        replace: true,
        template: '<div class="loading-icon"><div class="spinner"></div></div>'
    };
});

/* Directives */
_BannerFlowApp.directive("loadingOverlay", function ($location) {
    return {
        restrict: "E",
        replace: true,
        scope: {
            faded: "=?",
            small: "=?",
            gray: "=?",
            dark: "=?"
        },
        link: function (scope, element) {},
        template:
            '<div class="loading-overlay" ng-class="{ faded: faded, small: small, gray: gray, dark: dark }"><div class="spinner"></div></div>'
    };
});

_BannerFlowApp.directive("loadingOverlayGray", function ($location) {
    return {
        restrict: "E",
        replace: true,
        scope: {
            faded: "=?",
            small: "=?"
        },
        template:
            '<div class="loading-overlay gray" ng-class="{ faded: faded, small: small }"><div class="spinner"></div></div>'
    };
});
